import { useSortable } from "@dnd-kit/sortable";
import ICDRecommendation from "./ICDRecommendation";
import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { CSS } from '@dnd-kit/utilities';

const RenderDynamicICD = ({ id, icdIndex, icd, icdCodes, isDisabled, isICDDragDisabled, onSelect, inputRef, onRemove }) => {

    const sortableId = id?.toString?.() ?? "";
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: sortableId, animateLayoutChanges: () => false });

    const style = {
        transform: transform ? CSS.Transform.toString(transform) : undefined,
        transition,
        opacity: isDragging ? 0.5 : undefined,
        boxShadow: isDragging ? '0 4px 10px rgba(0, 0, 0, 0.2)' : undefined,
        borderRadius: '0.5rem',
        backgroundColor: isDragging ? '#f7fafc' : undefined,
        border: isDragging ? '1px solid #e2e8f0' : undefined,
    };

    return (
        <HStack ref={setNodeRef} style={style}>
            <Box flex={1.3} >
                <ICDRecommendation
                    index={icdIndex}
                    value={icd}
                    icdCodes={icdCodes}
                    isDisabled={isDisabled}
                    attributes={attributes}
                    listeners={listeners}
                    isDragging={isDragging}
                    isICDDragDisabled={isICDDragDisabled}
                    onSelect={onSelect}
                    inputRef={inputRef}
                />
            </Box>
            <Button
                size="xs"
                colorScheme="gray"
                isDisabled={isDisabled}
                onClick={onRemove}
            >
                <Text color="red.500" fontWeight="bold">-</Text>
            </Button>
        </HStack>
    );
};

export default RenderDynamicICD;  